<template>
  <div></div>
</template>

<script>

import {mapActions} from "vuex";
import {getCamStudyV2HomeUrl} from '@/utils/CamStudyV2Helper'

export default {
  name: 'MobileProxy',
  data() {
    return {
      isMobileDevice: false,
      v2CamsHomeUrl: '',
      token: '',
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('auth', ['mobileTokenLogin']),
    async init() {
      this.v2CamsHomeUrl = getCamStudyV2HomeUrl()

      this.token = this.$route.params?.token;
      if (!this.token || Number.isNaN(this.token)) {
        alert(this.$t('common.login.error.invalidToken'));
        window.location.href = this.v2CamsHomeUrl;
        return
      }

      try {
        await this.enterMobileRoom();
      } catch (e) {
        console.error(e);
        const errMsg = e.message;
        if (!errMsg) {
          return
        }
        const errorMapping = {
          'Invalid Token': 'common.login.error.invalidToken',
          'Not found user': 'common.login.error.notFoundUser',
        }
        const errorText = errorMapping[e.message] || 'common.login.error.default'
        alert(this.$t(errorText))
        window.location.href = this.v2CamsHomeUrl;
      }
    },
    async enterMobileRoom() {
      await this.mobileTokenLogin(this.token)
          .then(res => {
            const url = res.data.url;
            const locale = res.data.locale;

            this.saveLocaleSetting(locale);
            this.$router.push({path: url});
          })
    },
    saveLocaleSetting(lo) {
      const locale = lo && ['ko', 'en'].includes(lo) ? lo : 'en';
      this.$i18n.setLocale(locale);
    }
  }
}
</script>